import { toRaw, reactive } from "vue";

export const dialogs = reactive({
  loader: false,
  receipt_view: false,
  filter: false,
  column_selector: false,
  object_picker: false,
  editor: false,
  date_picker: false,
  invoice: false,
  yes_no: false,
  input_dialog: false,
  google_map: false,
  captcha: false,
});

export default class global_dialog {
  constructor() {
    this.last_dialog = "default";
    this.data = null;
    this.options = null;
    this.result = null;
    this.callbackz = {};

    this.showError = null;
    this.showInfo = null;
    // this.isShown = () => {
    //   return (
    //     dialogs.captcha ||
    //     dialogs.receipt_view ||
    //     dialogs.filter ||
    //     dialogs.column_selector ||
    //     dialogs.object_picker ||
    //     dialogs.editor ||
    //     dialogs.date_picker ||
    //     dialogs.invoice ||
    //     dialogs.yes_no ||
    //     dialogs.loader ||
    //     dialogs.google_map
    //   );
    // };

    this.dialog_types = {
      receipt_view: "receipt-view",
      filter_view: "filter-view",
      column_selector: "column-selector",
      picker: "picker-view",
      editor: "editor-view",
      date_picker: "date-picker",
      yes_no: "yes-no",
      input_dialog: "input-dialog",
      invoice: "invoice",
      loader: "loader",
      google_map: "google-map",
      captcha: "captcha",
    };

    this.close = async (noCallBack, onlyLoader) => {
      dialogs.loader = false;
      if (!onlyLoader) {
        dialogs.object_picker = false;
        dialogs.editor = false;
        dialogs.date_picker = false;
        dialogs.receipt_view = false;
        dialogs.filter = false;
        dialogs.column_selector = false;
        dialogs.input_dialog = false;
        dialogs.yes_no = false;
        dialogs.invoice = false;
        dialogs.google_map = false;
        dialogs.captcha = false;
      }
      const res = toRaw(this.result);
      const d = this.last_dialog;
      new Promise((resolve) => {
        if (this.callbackz[d] && !noCallBack) {
          this.callbackz[d](res);
          this.callbackz[d] = null;
        }
        this.last_dialog = "default";
        resolve();
      });
    };

    /**
     *
     * @param {dialog_types} dialog_name
     */
    this.show = async (dialog_name, data, options, cb) => {
      return new Promise((resolve) => {
        this.last_dialog = dialog_name;
        this.data = data;
        this.options = options;
        this.callbackz[this.last_dialog] = cb;
        if (dialog_name.toLowerCase() == this.dialog_types.receipt_view) {
          dialogs.receipt_view = true;
        } else if (dialog_name.toLowerCase() == this.dialog_types.filter_view) {
          dialogs.filter = true;
        } else if (dialog_name.toLowerCase() == this.dialog_types.column_selector) {
          dialogs.column_selector = true;
        } else if (dialog_name.toLowerCase() == this.dialog_types.picker) {
          dialogs.object_picker = true;
        } else if (dialog_name.toLowerCase() == this.dialog_types.editor) {
          dialogs.editor = true;
        } else if (dialog_name.toLowerCase() == this.dialog_types.date_picker) {
          dialogs.date_picker = true;
        } else if (dialog_name.toLowerCase() == this.dialog_types.yes_no) {
          dialogs.yes_no = true;
        } else if (dialog_name.toLowerCase() == this.dialog_types.input_dialog) {
          dialogs.input_dialog = true;
        } else if (dialog_name.toLowerCase() == this.dialog_types.invoice) {
          dialogs.invoice = true;
        } else if (dialog_name.toLowerCase() == this.dialog_types.loader) {
          dialogs.loader = true;
        } else if (dialog_name.toLowerCase() == this.dialog_types.google_map) {
          dialogs.google_map = true;
        } else if (dialog_name.toLowerCase() == this.dialog_types.captcha) {
          dialogs.captcha = true;
        }
        resolve();
      });
    };
  }
}
